var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAuthorizationHeaderValue } from '../axiosBaseQuery';
/**
 * Adds a request interceptor to wait for the refresh token.
 *
 * @param instance The axios instance.
 */
export function addRefreshTokenInterceptor(instance) {
    return __awaiter(this, void 0, void 0, function* () {
        instance.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = config.headers) === null || _a === void 0 ? void 0 : _a['Authorization']) {
                config.headers['Authorization'] = yield createAuthorizationHeaderValue();
            }
            return config;
        }));
    });
}
